/* Die Ladeleiste: füllt sich mit dem Scrollfortschritt.
   Kein Bild, kein Video, nur eine CSS-Variable. */
(function () {
  'use strict';

  function init() {
    var rail = document.querySelector('[data-bx-charge]');
    if (!rail) return;

    var fill = rail.querySelector('[data-bx-charge-fill]');
    var num = rail.querySelector('[data-bx-charge-num]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    var max = 1;
    var last = -1;
    var ticking = false;

    function measure() {
      max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    }

    function paint() {
      ticking = false;
      var y = window.scrollY || window.pageYOffset || 0;
      var k = y / max;
      if (k < 0) k = 0;
      if (k > 1) k = 1;
      // Bei 8 Prozent starten, damit von Anfang an etwas Ladung sichtbar ist.
      var shown = 0.08 + k * 0.92;
      var pct = Math.round(shown * 100);
      if (pct === last) return;
      last = pct;
      rail.style.setProperty('--bx-charge', shown.toFixed(4));
      rail.setAttribute('aria-valuenow', String(pct));
      rail.setAttribute('aria-valuetext', pct + ' Prozent geladen');
      if (num) num.textContent = pct + ' %';
      rail.classList.toggle('is-full', pct >= 99);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(paint);
    }

    measure();
    paint();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); last = -1; onScroll(); }, { passive: true });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { measure(); last = -1; onScroll(); });
      ro.observe(document.body);
    }
    rail.hidden = false;

    // Die drei Lieferschritte laden sich nacheinander auf.
    var steps = document.querySelectorAll('[data-bx-step]');
    if (!steps.length) return;
    if (reduce.matches || !('IntersectionObserver' in window)) {
      steps.forEach(function (s) { s.classList.add('is-charged'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var i = parseInt(el.dataset.bxStep, 10) || 0;
        window.setTimeout(function () { el.classList.add('is-charged'); }, i * 260);
        io.unobserve(el);
      });
    }, { threshold: 0.35 });
    steps.forEach(function (s) { io.observe(s); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
